import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 2,
  id: "main-content",
  tabindex: "-1"
}
const _hoisted_2 = { class: "vstack fixed-bottom" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ApplicationHeader = _resolveComponent("ApplicationHeader")!
  const _component_LoadingAccessToken = _resolveComponent("LoadingAccessToken")!
  const _component_InvalidSession = _resolveComponent("InvalidSession")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_error_messages = _resolveComponent("error-messages")!

  return (_openBlock(), _createElementBlock("div", null, [
    _cache[0] || (_cache[0] = _createElementVNode("a", {
      href: "#main-content",
      class: "skip-link"
    }, "Skip to main content", -1)),
    _createVNode(_component_ApplicationHeader),
    (_ctx.sessionStore.accessToken === '' || _ctx.sessionStore.uvid == '' )
      ? (_openBlock(), _createBlock(_component_LoadingAccessToken, { key: 0 }))
      : (_ctx.sessionStore.invalidAccessToken || _ctx.sessionStore.session_issues)
        ? (_openBlock(), _createBlock(_component_InvalidSession, { key: 1 }))
        : (_openBlock(), _createElementBlock("main", _hoisted_1, [
            _createVNode(_component_router_view)
          ])),
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sessionStore.error_messages, (error_message, error_index) => {
        return (_openBlock(), _createBlock(_component_error_messages, {
          key: error_index,
          error_message: error_message,
          error_index: error_index
        }, null, 8, ["error_message", "error_index"]))
      }), 128))
    ])
  ]))
}